import { httpRequest, Response } from '~/networking/utils/httpRequest';

import { getHeaders, getRequestUrl } from '~/networking/api/cms/requests/cmsRequest';
import type { CMSTradeRegion } from '~/networking/api/cms/responses/CMSRegion';

export const getRegionByName = async (name: string): Promise<Response<CMSTradeRegion | undefined>> => {
    const headers = getHeaders(true);
    return httpRequest.get(getRequestUrl(`/api/product/regions/${encodeURIComponent(name.toLocaleLowerCase())}`), {
        headers,
        keepalive: true
    });
};
